export default __webpack_public_path__ + "static/media/insta.6b88b90f.webp";